import { render, staticRenderFns } from "./UserInvitationHistoryModal.vue?vue&type=template&id=30250384&"
import script from "./UserInvitationHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./UserInvitationHistoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserInvitationHistoryModal.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports